<app-alert [isDismissable]="false" *ngIf="needsUpdate$ | async">
	<h3>Hej!</h3>

	<p>
		IKEA Media Content Centre has been updated. Refresh the page to get the best
		possible experience.
	</p>

	<button class="fm-btn fm-btn--filled" (click)="updateApplication()">
		Refresh now
	</button>
</app-alert>
